import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { ModulosController } from '../../modulos-controller';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { ConvenioService } from '../../../../providers/convenio-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { UsuarioService } from '../../../../providers/usuario-service';
import { TomadaDeContaService } from '../../../../providers/tce-service';

import { ModalResponsavelTcePage } from '../../../modais/modal-responsavel-tce/modal-responsavel-tce';

declare var jsPDF: any;

@Component({
  selector: 'page-comunicacao-inadimplencia',
  templateUrl: 'comunicacao-inadimplencia.html',
  providers: [
    TomadaDeContaService
  ]
})
export class ConvenioComunicacaoInadimplenciaPage extends ModulosController {

  listaFatores: any = [];
  listaConvenio: any = [];
  comboFatoGerador: any = [];

  inciso: string = "";
  incisoI: string = "I - nos casos de omissão no dever de prestar contas, do primeiro dia subsequente ao vencimento do prazo para apresentação da prestação de contas.";
  incisoII: string = "II - nos casos em que os elementos constantes das contas apresentadas não permitirem a conclusão de que a aplicação dos recursos observou as normas pertinentes e/ou atingiu os fins colimados, da data limite para análise da prestação de contas";
  incisoIII: string = "III - nos demais casos, da data do evento ilegítimo ou antieconômico, quando conhecida, ou da data da ciência do fato pela administração.";

  myDatePickerDataPub: IMyDpOptions;

  cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];

  cpfInvalido: boolean = false;

  cpfConvInvalido: boolean = false;
  cnpjInvalido: boolean = false;

  flTipo: any = 'true';

  verificacao: boolean = true;

  idModuloAnalise: any;

  objetoTCE: any = {
    "idComunicacaoInadimplencias": 0,
    "nmSacc": "",
    "nmSic": "",
    "dataPublicacao": "",
    "motivo": "",
    "nomeConvenente": "",
    "cpfConv": "",
    "cnpj": "",
    "valor": "",
    "dano": "",
    "danoFinal": "",
    "responsaveis": [],
    "fatorGeradorInadimplencia": "",
    "detalhamentoFatorGeradorInadimplencia": "",
    "medidasAdotadas": "",
    "houveSaneamento": "true",
    "resultadoSaneamento": "",
    "idModuloAnalise": 0
  }

  analise: any = null;

  @ViewChild('inputCnpj') inputCnpj: ElementRef;
  @ViewChild('inputCpf') inputCpf: ElementRef;
  habilita: boolean = false;

  loading: boolean = true;

  @ViewChild('inputFileCM')
  inputFileCMVar: ElementRef;

  selecionarTodosChecked = false;

  constructor(public navCtrl: NavController,
    public alertService: AlertService,
    public navParams: NavParams,
    public convenioService: ConvenioService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    public tomadaDeContaService: TomadaDeContaService,
    public gestaoPcaService: GestaoPcaService,
    private menuService: MenuService,
    private renderer: Renderer2) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    this.analise = this.navParams.get('analise');

    this.myDatePickerDataPub = {
      dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
      monthLabels: {
        1: 'Jan',
        2: 'Fev',
        3: 'Mar',
        4: 'Abr',
        5: 'Mai',
        6: 'Jun',
        7: 'Jul',
        8: 'Ago',
        9: 'Set',
        10: 'Out',
        11: 'Nov',
        12: 'Dez'
      },
      dateFormat: 'dd/mm/yyyy',
      todayBtnTxt: 'Hoje',
      firstDayOfWeek: 'su',
      disableWeekends: false,
      editableDateField: true,
      openSelectorOnInputClick: true,
      showClearDateBtn: false
    };


    this.idModuloAnalise = this.navParams.get('analise').idModuloAnalise;

    this.carregarModulo();
    this.carregarFatores();
    this.setModuloId(6);
  }

  carregarModulo() {
    this.listar();
  }

  listar() {
    this.loading = true;
    this.convenioService.listarConvenioComunicacaoInadimplencia().subscribe(data => {
      this.listaConvenio = data;
      this.selecionarTodosChecked = false;
      this.loading = false;
    }, error => {
      this.alertService.mostraAlerta("", "Houve um problema ao listar.");
      this.loading = false;
    });
  }

  onDatePickerDataMedidas(event: IMyDateModel) {
    if (event.jsdate === null) {
      this.objetoTCE.dataAdocaoMedidaAdministrativa = null;
    }
    else {
      this.objetoTCE.dataAdocaoMedidaAdministrativa = new Date(event.jsdate).toLocaleDateString('pt-br');
    }
  }

  adicionarConvenio() {

    if (this.objetoTCE.valor == "" || this.objetoTCE.valor == null || this.objetoTCE.valor == undefined || isNaN(this.objetoTCE.valor)) {
      this.objetoTCE.valor = 0;
    }

    if (this.objetoTCE.dano == "" || this.objetoTCE.dano == null || this.objetoTCE.dano == undefined || isNaN(this.objetoTCE.dano)) {
      this.objetoTCE.dano = 0;
    }

    if (this.objetoTCE.danoFinal == "" || this.objetoTCE.danoFinal == null || this.objetoTCE.danoFinal == undefined || isNaN(this.objetoTCE.danoFinal)) {
      this.objetoTCE.danoFinal = 0;
    }

    let validaTipo = false;
    if (this.flTipo == "false") {
      validaTipo = true;
    } else {
      if (this.objetoTCE.nmSacc != ''
        && this.objetoTCE.nmSic != ''
        && this.objetoTCE.nomeConvenente != ''
        && this.objetoTCE.valor != 0) {
        validaTipo = true;
      } else {
        validaTipo = false;
      }
    }

    if (this.objetoTCE.flEnviada == "true") {
      this.objetoTCE.flEnviada = true;
    } else {
      this.objetoTCE.flEnviada = false;
    }

    if (this.cpfConvInvalido || this.cnpjInvalido) {
      this.alertService.mostraAlerta("", "O CPF/CNPJ informado é inválido.");
      return;
    }

    if (this.objetoTCE.cpfConv) {
      this.objetoTCE.cpfConv = this.objetoTCE.cpfConv.replace(/\D/g, '');
    }

    if (this.objetoTCE.cnpj) {
      this.objetoTCE.cnpj = this.objetoTCE.cnpj.replace(/\D/g, '');
    }

    let objetoTCETela = {
      "idComunicacaoInadimplencias": this.objetoTCE.idComunicacaoInadimplencias != 0 ? this.objetoTCE.idComunicacaoInadimplencias : 0,
      "nmSacc": this.objetoTCE.nmSacc,
      "nmSic": this.objetoTCE.nmSic,
      "dataPublicacao": this.objetoTCE.dataPublicacao,
      "motivo": this.objetoTCE.motivo,
      "nomeConvenente": this.objetoTCE.nomeConvenente,
      "cpfConv": this.objetoTCE.cpfConv,
      "cnpj": this.objetoTCE.cnpj,
      "valor": this.objetoTCE.valor,
      "dano": this.objetoTCE.dano,
      "danoFinal": this.objetoTCE.danoFinal,
      "responsaveis": this.verificarListaResponsaveis(this.objetoTCE.responsaveis) ? this.objetoTCE.responsaveis : [],
      "fatorGeradorInadimplencia": this.objetoTCE.fatorGeradorInadimplencia,
      "detalhamentoFatorGeradorInadimplencia": this.objetoTCE.detalhamentoFatorGeradorInadimplencia,
      "medidasAdotadas": this.objetoTCE.medidasAdotadas,
      "houveSaneamento": this.objetoTCE.houveSaneamento.toString().toLowerCase(),
      "resultadoSaneamento": this.objetoTCE.resultadoSaneamento,
      "idModuloAnalise": this.objetoTCE.idModuloAnalise != 0 || this.objetoTCE.idModuloAnalise != "" ? this.objetoTCE.idModuloAnalise : 0
    }

    if (
      this.objetoTCE.dataPublicacao &&
      this.objetoTCE.motivo &&
      validaTipo &&
      this.objetoTCE.dano !== null && this.objetoTCE.dano !== undefined &&
      this.objetoTCE.danoFinal !== null && this.objetoTCE.danoFinal !== undefined &&
      this.objetoTCE.detalhamentoFatorGeradorInadimplencia &&
      this.objetoTCE.medidasAdotadas &&
      this.objetoTCE.resultadoSaneamento) {

      this.selecionarTodosChecked = false;
      this.listaConvenio.push(objetoTCETela);

      this.objetoTCE.nmSacc = '';
      this.objetoTCE.nmSic = '';
      this.objetoTCE.dataPublicacao = null;
      this.objetoTCE.motivo = null;
      this.objetoTCE.nomeConvenente = '';
      this.objetoTCE.valor = '';
      this.objetoTCE.dano = '';
      this.objetoTCE.danoFinal = '';
      this.objetoTCE.responsaveis = [],
        this.objetoTCE.fatorGeradorInadimplencia = '';
      this.objetoTCE.medidasAdotadas = '';
      this.objetoTCE.resultadoSaneamento = '';
      this.objetoTCE.cpfConv = '';
      this.objetoTCE.cnpj = '';
      this.objetoTCE.detalhamentoFatorGeradorInadimplencia = '';
      this.objetoTCE.houveSaneamento = null;

      this.comboFatoGerador = null;
    }
    else {
      this.alertService.mostraAlerta("", "Verifique os campos do formulário não preenchidos.");
    }
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  voltarParaResumo() {
    this.menuService.redirecionarPagina(this.tomadaDeContaService.obterIdPaginaTomadaDeConta());
  }

  salvar() {
    this.convenioService.salvarConvenioComunicacaoInadimplencia(this.listaConvenio).subscribe(data => {
      this.alertService.mostraAlerta("", "Comunicação de inadimplência salva com sucesso.");
      this.carregarModulo();
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar o convênio:" + error);
    });
  }

  finalizar() {
    let valida = true;

    this.listaConvenio.forEach(element => {
      if (element.responsaveis.length == 0) {
        valida = false;
      }
    });

    if (valida) {
      this.convenioService.finalizarConvenioComunicacaoInadimplencia(this.listaConvenio).subscribe(data => {
        this.alertService.mostraAlerta("", "Análise finalizada com sucesso.");
        this.voltarParaResumo();
      }, error => {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar a analise:" + error);
      });
    } else {
      this.alertService.mostraAlerta("Erro ao Finalizar", "Existem TCE's que não possuem responsável atribuído.");
    }
  }

  remover(item) {
    if (item.idComunicacaoInadimplencias != undefined && item.idComunicacaoInadimplencias > 0) {
      this.alertService.mostraModalConfirmacao("Remover", "Deseja remover o item?", callback => {
        if (callback) {
          if (item.idComunicacaoInadimplencias != "0") {
            this.convenioService.deletarConvenioComunicacaoInadimplencia(item.idComunicacaoInadimplencias).subscribe(data => {
              // this.listaConvenio = this.listaConvenio.filter(obj => obj !== item);

              let index = this.listaConvenio.indexOf(item);
              this.listaConvenio.splice(index, 1);

            }, error => {
              this.alertService.mostraAlerta("", "Ocorreu um erro ao remover o registro.:" + error);
            });
          }
        }
      });
    } else {
      // this.listaConvenio = this.listaConvenio.filter(obj => obj !== item);
      let index = this.listaConvenio.indexOf(item);
      this.listaConvenio.splice(index, 1);
    }
  }

  excluirSelecionados() {

    let qtdeSelecionados = 0;
    this.listaConvenio.forEach(item => qtdeSelecionados += item.checked);

    if (qtdeSelecionados == 0) {
      this.alertService.mostraAlerta("", "Selecione pelo menos um registro para excluir!");
      return;
    }

    let registrosTexto = qtdeSelecionados + (qtdeSelecionados == 1 ? " registro?" : " registros?");

    this.alertService.mostraModalConfirmacao("Excluir " + registrosTexto,
      "Deseja continuar com a exclusão de "
      + registrosTexto + "<br/>"
      + "Após a exclusão, os registros serão recarregados. Certifique-se de salvar possíveis alterações antes de prosseguir!",
      callback => {
        if (callback) {
          this.loading = true;

          let listaId = this.listaConvenio
            .filter(item => item.checked)
            .map(item => item.idComunicacaoInadimplencias);

          this.convenioService.deletarConvenioComunicacaoInadimplenciaLista(listaId, this.selecionarTodosChecked, this.idModuloAnalise).subscribe(data => {
            this.listar();
            this.alertService.mostraAlerta("", data.mensagem);
          }, error => {
            this.listar();
            this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir: " + error.mensagem);
          });
        }
      }
    );
  }

  truncateText(text) {
    let numberOfWordsToTruncate = 10;

    if (text != undefined) {
      let separatedByWords = text.toString().split(" ");

      if (this.needTruncate(text)) {
        return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
      }
      else {
        return text;
      }
    }
  }

  carregarFatores() {
    this.tomadaDeContaService.listarFatoresGeradores().subscribe(data => this.listaFatores = data, error => console.log("erro: " + error));
  }

  onFatoresChange(itemFatores) {

    this.objetoTCE.fatorGeradorInadimplencia = itemFatores.codigo;
    this.objetoTCE.detalhamentoFatorGeradorInadimplencia = itemFatores.valor;

    if (itemFatores.codigo == 0) {
      this.inciso = this.incisoI;
    }

    if (itemFatores.codigo == 1) {
      this.inciso = this.incisoII;
    }

    if (itemFatores.codigo == 2) {
      this.inciso = this.incisoIII;
    }

  }

  needTruncate(text) {
    if (text) {
      let separatedByWords = text.toString().split(" ");
      let numberOfWordsToTruncate = 10;
      return separatedByWords.length >= numberOfWordsToTruncate;
    }
  }

  exibirCompleto(text) {
    this.alertService.mostraAlerta('', text);
  }

  templateCargaEmMassa() {
    let CodTemplate = 2 // Codigo do template.
    this.convenioService.downloadTemplateCargaMassa(CodTemplate);
  }

  cargaEmMassa(event) {
    this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?",
      retornoModal => {
        if (retornoModal) {
          this.loading = true;
          this.convenioService.cargaMassaConvenioComunicacaoInadimplencia(event).subscribe(data => {
            this.inputFileCMVar.nativeElement.value = "";

            if (data && data.length > 0) {
              this.selecionarTodosChecked = false;
            }

            for (let item of data) {
              this.listaConvenio.push(item);
            }

            this.alertService.mostraAlerta("Importação concluída.", "Para efetivar a importação, clique em salvar ou finalizar.");
            this.loading = false;
          }, error => {
            this.inputFileCMVar.nativeElement.value = "";
            this.alertService.mostraAlerta("Houve um erro ao carregar arquivo.", error.mensagem);
            this.loading = false;
          });
        } else {
          this.inputFileCMVar.nativeElement.value = "";
        }
      }
    );
  }

  redirecionarParaAnalise(item) {

    let analise = this.navParams.get('analise');

    analise.idProcesso = item.idComunicacaoInadimplencias;
    analise.cdAnalise = "2121"
    this.menuService.redirecionarSubPagina(this.tomadaDeContaService.obterIdPaginaTomadaDeConta(), analise);
  }

  editar(item) {

    let index = this.listaConvenio.indexOf(item);
    this.listaConvenio.splice(index, 1);

    this.objetoTCE.responsaveis = [];

    item.responsaveis.forEach(r => {

      let resp = {
        "idResponsavel": 0,
        "cpf": '',
        "nomeResponsavel": ''
      };

      resp.cpf = r.cpf;
      resp.nomeResponsavel = r.nomeResponsavel;

      this.objetoTCE.responsaveis.push(resp);
    });

    this.objetoTCE.idComunicacaoInadimplencias = item.idComunicacaoInadimplencias;
    this.objetoTCE.nmSacc = item.nmSacc;
    this.objetoTCE.nmSic = item.nmSic;
    this.objetoTCE.dataPublicacao = item.dataPublicacao;
    this.objetoTCE.motivo = item.motivo;
    this.objetoTCE.nomeConvenente = item.nomeConvenente;
    this.objetoTCE.cpfConv = item.cpfConv;
    this.objetoTCE.cnpj = item.cnpj;
    this.objetoTCE.valor = item.valor;
    this.objetoTCE.dano = item.dano;
    this.objetoTCE.danoFinal = item.danoFinal;
    this.objetoTCE.medidasAdotadas = item.medidasAdotadas;
    this.objetoTCE.houveSaneamento = item.houveSaneamento;
    this.objetoTCE.resultadoSaneamento = item.resultadoSaneamento;
    this.objetoTCE.idModuloAnalise = item.idModuloAnalise;

    for (let itemList of this.listaFatores) {
      if (item.fatorGeradorInadimplencia == itemList.codigo) {
        this.comboFatoGerador = itemList;
        this.objetoTCE.fatorGeradorInadimplencia = itemList.codigo;
        this.objetoTCE.detalhamentoFatorGeradorInadimplencia = itemList.valor;
      }
    }

    if (this.objetoTCE.cnpj == undefined || this.objetoTCE.cnpj == '') {
      this.habilita = false;
    } else {
      this.habilita = true;
    }

    this.flTipo = item.nomeConvenente ? 'true' : 'false';
  }

  cpf_mask(v) {
    v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
    return v;
  }

  validarCPFConv(cpf) {

    if (cpf != undefined) {
      cpf = cpf.replace(/[^\w\s]/gi, '');

      if (cpf == '') {
        this.cpfConvInvalido = true;
        return false;
      }

      if (cpf.length != 11) {
        this.cpfConvInvalido = true;
        return false;
      }

      // Elimina CPFs invalidos conhecidos
      if (cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" ||
        cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" ||
        cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") {
        this.cpfConvInvalido = true;
        return false;
      }

      // Valida 1o digito
      let add = 0;
      for (let i = 0; i < 9; i++)
        add += parseInt(cpf.charAt(i)) * (10 - i);
      let rev = 11 - (add % 11);
      if (rev == 10 || rev == 11)
        rev = 0;
      if (rev != parseInt(cpf.charAt(9))) {
        this.cpfConvInvalido = true;
        return false;
      }

      // Valida 2o digito
      add = 0;
      for (let i = 0; i < 10; i++) {
        add += parseInt(cpf.charAt(i)) * (11 - i);
      }
      rev = 11 - (add % 11);
      if (rev == 10 || rev == 11)
        rev = 0;
      if (rev != parseInt(cpf.charAt(10))) {
        this.cpfConvInvalido = true;
        return false;
      }
    }

    this.cpfConvInvalido = false;
    return true;
  }

  onCPFAlterado(event) {

    let value = event.replace(/\D/g, '');

    if (value.length > 11) {
      this.habilita = true;

      const element = this.renderer.selectRootElement('.cnpj');
      setTimeout(() => {
        element.focus();
      }, 1);

      this.cpfConvInvalido = false;

      this.objetoTCE.cnpj = this.cnpj_mask(value);
      this.objetoTCE.cpfConv = undefined;

      this.validarCNPJ(this.cnpj_mask(value));

    } else {
      this.validarCPFConv(this.objetoTCE.cpfConv);
      this.objetoTCE.cpfConv = this.cpf_mask(value);
    }
  }

  onCNPJAlterado(event) {
    let value = event.replace(/\D/g, '');
    if (value.length < 12) {
      this.habilita = false;
      this.objetoTCE.cnpj = undefined;
      this.objetoTCE.cpfConv = this.cpf_mask(value);

      const element = this.renderer.selectRootElement('.cpf');

      setTimeout(() => {
        element.focus();
      }, 1);

      this.validarCPFConv(this.cpf_mask(value));
      this.cnpjInvalido = false;

    } else {
      this.validarCNPJ(this.objetoTCE.cnpj)
      this.objetoTCE.cnpj = this.cnpj_mask(value);
    }
  }

  cnpj_mask(v) {
    v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
    v = v.replace(/(\d{2})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    v = v.replace(/(\d{3})(\d)/, '$1/$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{4})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
    return v;
  }

  validarCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj == '') {
      this.cnpjInvalido = false;
      return false;
    }

    if (cnpj.length != 14) {
      this.cnpjInvalido = false;
      return false;
    }

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
      cnpj == "11111111111111" ||
      cnpj == "22222222222222" ||
      cnpj == "33333333333333" ||
      cnpj == "44444444444444" ||
      cnpj == "55555555555555" ||
      cnpj == "66666666666666" ||
      cnpj == "77777777777777" ||
      cnpj == "88888888888888" ||
      cnpj == "99999999999999") {
      this.cnpjInvalido = true;
      return false;
    }

    let tamanho: any;
    let numeros: any;
    let digitos: any;
    let soma: any;
    let pos: any;
    let resultado: any;

    // Valida DVs
    tamanho = cnpj.length - 2
    numeros = cnpj.substring(0, tamanho);
    digitos = cnpj.substring(tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0)) {
      this.cnpjInvalido = true;
      return false;
    }

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1)) {
      this.cnpjInvalido = true;
      return false;
    }

    //this.cnpjInvalido = true;
    return true;
  }

  modalResponsaveis(item) {
    this.apresentaModalResponsaveis("Responsáveis", item, ModalResponsavelTcePage);
  }

  apresentaModalResponsaveis(titulo: String, objeto: any, modalPage: any) {
    let modal = this.modalCtrl.create(modalPage, {
      tce: objeto,
      jurisdicionado: this.isJurisdicionado,
      isCGE: this.isCGE
    });
    modal.onDidDismiss(retornoModal => {

      if (retornoModal && retornoModal.salvar && this.isJurisdicionado) {

        retornoModal.tce.responsaveis = retornoModal.tce.responsaveis.filter(function (element) {
          return element !== undefined;
        });

        this.listaConvenio.forEach(item => {
          if (item.idComunicacaoInadimplencias === retornoModal.tce.id
            && item.nmSacc === retornoModal.tce.nmSacc
            && item.nmSic === retornoModal.tce.nmSic
            && item.dataPublicacao === retornoModal.tce.dataPublicacao
            && item.dano === retornoModal.tce.dano
            && item.danoFinal === retornoModal.tce.danoFinal
            && item.ds_situacao === retornoModal.tce.detalhamentoFatorGeradorInadimplencia
            && item.medidasAdotadas === retornoModal.tce.medidasAdotadas
            && item.resultadoSaneamento === retornoModal.tce.resultadoSaneamento) {

            item.responsaveis = retornoModal.tce.responsaveis;
          }
        });

        this.alertService.mostraAlerta("", "Responsáveis salvos com sucesso.");

      }
    });
    modal.present();
  }

  onDatePickerDataPub(event: IMyDateModel) {
    if (event.jsdate === null) {
      this.objetoTCE.dataPublicacao = null;
    }
    else {
      this.objetoTCE.dataPublicacao = new Date(event.jsdate).toLocaleDateString('pt-br');
    }
  }

  printData() {

    var doc = new jsPDF("l");

    var totalPagesExp = "{total_pages_count_string}";

    var pageContent = function (data) {
      // HEADER
      doc.setFontSize(20);
      doc.setTextColor(40);
      doc.setFontStyle('normal');

      doc.text("Casos de Dispensa de Instauração de Tomadas de Contas Especiais", data.settings.margin.left + 15, 22);

      // FOOTER
      var str = "Page " + data.pageCount;
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + " of " + totalPagesExp;
      }
      doc.setFontSize(10);
      doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
    };

    var columns = [
      { title: "Nº SACC/e-Parcerias/SCC do Convênio", dataKey: "sacc" },
      { title: "Nº SIC", dataKey: "sic" },
      { title: "Convenente/Parceiro", dataKey: "nomeConv" },
      { title: "CPF Convenente/Parceiro", dataKey: "cpfConv" },
      { title: "Valor Convênio", dataKey: "valorConv" },
      { title: "Dano Inicial", dataKey: "danoInicial" },
      { title: "Dano Final", dataKey: "danoFinal" },
      { title: "Responsáveis Cadastrados?", dataKey: "resp" },
      { title: "Fato Gerador", dataKey: "fato" },
      { title: "Houve Saneamento?", dataKey: "saneamento" }
    ];

    let rows = [];

    this.listaConvenio.forEach(element => {

      let resp;

      if (element.responsaveis.length == 0) {
        resp = "Não";
      } else {
        resp = "Sim";
      }

      var item = {
        "sacc": element.nmSacc != null ? element.nmSacc : "",
        "sic": element.nmSic != null ? element.nmSic : "",
        "nomeConv": element.nomeConvenente != null ? element.nomeConvenente : "",
        "cpfConv": element.cpfConv != null ? element.cpfConv : "",
        "valorConv": this.formatarValorNumerico(element.valor) != null ? this.formatarValorNumerico(element.valor) : "",
        "danoInicial": element.dano != null ? this.formatarValorNumerico(element.dano) : "",
        "danoFinal": element.danoFinal != null ? this.formatarValorNumerico(element.danoFinal) : "",
        "resp": resp,
        "fato": element.fatorGeradorInadimplencia != null ? element.fatorGeradorInadimplencia + " - " + element.detalhamentoFatorGeradorInadimplencia : "",
        "saneamento": element.houveSaneamento ? "Sim" : "Não"
      };

      rows.push(item);
    });

    doc.autoTable(columns, rows, {
      //     theme: 'grid',
      //     addPageContent: pageContent,
      //     margin: { top: 30 },
      //     styles: {
      //         overflow: 'linebreak', // visible, hidden, ellipsize or linebreak
      //         columnWidth: 'auto'
      //     }
      // });

      theme: 'grid',
      addPageContent: pageContent,
      margin: {
        top: 30,
        left: 5
      },
      styles: {
        overflow: 'linebreak',
        columnWidth: 'wrap',
        fontSize: 7
      },
      columnStyles: {
        text: { columnWidth: 'auto' }
      }
    });

    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }

    doc.save('dispensa_tce.pdf');
  }

  verificarListaResponsaveis(responsaveis): boolean {
    if (responsaveis != null && responsaveis.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  selecionarTodos() {
    setTimeout(() => {
      this.listaConvenio.forEach(
        item => item.checked = this.selecionarTodosChecked);
    });
  }

  selecionarItem() {
    const totalItems = this.listaConvenio.length;
    let checked = 0;
    this.listaConvenio.map(obj => {
      if (obj.checked) checked++;
    });
    this.selecionarTodosChecked = checked == totalItems;
  }

}



// WEBPACK FOOTER //
// ./src/pages/modulos/convenios/comunicacao-inadimplencia/comunicacao-inadimplencia.ts